import { StyledDropdown } from './styles';

export const DropDown = ({ children }: { children: React.ReactNode }) => {
  return <StyledDropdown>{children}</StyledDropdown>;
};
